import { useState, createContext, useContext } from "react"

// The initial state, you can setup any properties initilal values here.
const initialState = {
    logged_in: false
}

// create the context object for delivering your state across your app.
const GlobalContext = createContext(null)

export function GlobalContextProvider(props) {
  // declare the GlobalState
  const [globalState, setGlobalState] = useState({...initialState})

  return (
    <GlobalContext.Provider value={[globalState, setGlobalState]}>{props.children}</GlobalContext.Provider>
  )
}

export function useGlobalState() {
  return useContext(GlobalContext)
}